/** Legal operator — same entity as https://interlok.netlify.app/legal/terms */

export const legalOperator = {
  /** Registered legal entity (privacy, terms, contracts). */
  name: "MALVA INFORMATICA SL",
  /** Public-facing trade name for marketing/footer copy. */
  dbaName: "ArtlessDev",
  cif: "B55378855",
  address: "Calle Roger de Flor 78, Badalona 08912, Barcelona, Spain",
  email: "admin@binskea.com",
} as const

export const legalAepdUrl = "https://www.aepd.es"
